import type { IconName } from "@similarweb/icons";

import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import {
    MY_INTEGRATIONS_DYNAMICS_CRM_EMPTY_TEXT,
    MY_INTEGRATIONS_HS_CRM_EMPTY_TEXT,
    MY_INTEGRATIONS_SF_CRM_EMPTY_TEXT,
} from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";
import {
    DYNAMICS_INTEGRATION_MANUAL_URL,
    HUBSPOT_INTEGRATION_MANUAL_URL,
    SALESFORCE_INTEGRATION_MANUAL_URL,
} from "app/pages/sales-intelligence/modules/management/sub-modules/constants";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { managementActions } from "app/pages/sales-intelligence/sub-modules/management/store/action-creators";
import { getDynamicsStatusThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/dynamics/status";
import { getHubspotStatusThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/hubspot/status";
import { getSalesforceStatusThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/salesforce/status";
import {
    selectDynamicsLoadingState,
    selectDynamicsStatusResponse,
} from "app/pages/sales-intelligence/sub-modules/management/store/selectors/dynamicsSelectors";
import {
    selectHubspotLoadingState,
    selectHubspotStatusResponse,
} from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspotSelectors";
import {
    selectSalesforceLoadingState,
    selectSalesforceStatusResponse,
} from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforceSelectors";

import type { CrmStatusConfig } from "../types/crmStatusConfig";

export const CRM_INTEGRATION_MANUAL_URLS: Partial<Record<CrmIntegrationProvider, string>> = {
    hubspot: HUBSPOT_INTEGRATION_MANUAL_URL,
    salesforce: SALESFORCE_INTEGRATION_MANUAL_URL,
    dynamics: DYNAMICS_INTEGRATION_MANUAL_URL,
};

export const CRM_INTEGRATION_EMPTY_TEXT: Record<CrmIntegrationProvider, string> = {
    hubspot: MY_INTEGRATIONS_HS_CRM_EMPTY_TEXT,
    salesforce: MY_INTEGRATIONS_SF_CRM_EMPTY_TEXT,
    dynamics: MY_INTEGRATIONS_DYNAMICS_CRM_EMPTY_TEXT,
};

export const CRM_INTEGRATION_HOOK_NAME: Record<CrmIntegrationProvider, string> = {
    hubspot: "HubspotIntegrationAccess",
    salesforce: "SalesforceIntegrationAccess",
    dynamics: "DynamicsIntegrationAccess",
};

export const CRM_INTEGRATION_ICON: Record<CrmIntegrationProvider, IconName> = {
    hubspot: "hubspot-orange",
    salesforce: "salesforce-blue",
    dynamics: "dynamics-colored",
};

export const CRM_STATUS_CONFIG: Record<CrmIntegrationProvider, CrmStatusConfig> = {
    salesforce: {
        disconnectApi: salesApiService.management.disconnectSalesforce,
        getStatusThunk: getSalesforceStatusThunk,
        selectStatusResponse: selectSalesforceStatusResponse,
        selectIsLoading: selectSalesforceLoadingState,
        disconnectAction: managementActions.salesforce.disconnectSalesforceAsync,
    },
    hubspot: {
        disconnectApi: salesApiService.management.disconnectHubspot,
        getStatusThunk: getHubspotStatusThunk,
        selectStatusResponse: selectHubspotStatusResponse,
        selectIsLoading: selectHubspotLoadingState,
        disconnectAction: managementActions.hubspot.disconnectHubspotAsync,
    },
    dynamics: {
        disconnectApi: salesApiService.management.disconnectDynamics,
        getStatusThunk: getDynamicsStatusThunk,
        selectStatusResponse: selectDynamicsStatusResponse,
        selectIsLoading: selectDynamicsLoadingState,
        disconnectAction: managementActions.dynamics.disconnectDynamicsAsync,
    },
};
